// auth.actions.ts
import { createAction, props } from '@ngrx/store';
import { User } from '../../interfaces/user-interfaces';
import { Permission } from '../../enums/permissions.enum';
import { ErrorLog } from './auth.state';

// Action for logging in
export const login = createAction('[Auth] Login', props<{ token: string; user: User | null }>());

// Action for logging out
export const logout = createAction('[Auth] Logout');

// Action for handling login failure
export const loginFailure = createAction('[Auth] Login Failure', props<{ error: ErrorLog }>());

// Action for setting user permissions (useful when permissions might update separately)
export const setPermissions = createAction('[Auth] Set Permissions', props<{ permissions: Permission[] }>());

// Action for handling permission update failures
export const setPermissionsFailure = createAction('[Auth] Set Permissions Failure', props<{ error: ErrorLog }>());
